module.exports = __webpack_public_path__ + "static/media/How to create client tags.9c446b05.png";